import 'styles/cart/membership-conflict-modal.scss';

import React from 'react';
import Cookie from 'js-cookie';

import Modal from 'common/components/modals/Modal';
import Button from 'common/components/Button';
import { editMembershipPods as managePath } from 'apps/account/paths';
import { TranslatedMessage } from 'common/components/Intl';
import * as paths from 'apps/cart/paths';

export const COOKIE_KEY_MEMBERSHIP_CONFLICT_TYPE = 'membershipConflictType';

export default class MembershipConflictModal extends React.Component {
  state = {
    isClosed: false,
    shouldRedirectToManageAfterSave: false,
  };

  handleManageSubscription = () => {
    this.props.wipeCart();
    this.setState({ shouldRedirectToManageAfterSave: true });
  };

  handleOneOffPurchase = () => {
    this.clearCookieAndRedirect(paths.checkout());
  };

  clearCookieAndRedirect = url => {
    Cookie.remove(COOKIE_KEY_MEMBERSHIP_CONFLICT_TYPE);
    document.location.assign(url);
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.isSaving === false &&
      this.state.shouldRedirectToManageAfterSave
    ) {
      this.setState({ shouldRedirectToManageAfterSave: false });
      this.clearCookieAndRedirect(managePath());
    }
  }

  get conflictType() {
    return Cookie.get(COOKIE_KEY_MEMBERSHIP_CONFLICT_TYPE);
  }

  get isOpen() {
    return !!this.conflictType;
  }

  render() {
    const manageButtonText =
      this.conflictType === 'canceled' ? (
        <TranslatedMessage
          id={'cart.membership_conflict_modal.button_reactivate'}
        />
      ) : (
        <TranslatedMessage
          id={'cart.membership_conflict_modal.button_current'}
        />
      );
    return (
      <Modal
        className="MembershipConflictModal"
        bodyClassName="MembershipConflictModal__body"
        processing={this.state.shouldRedirectToManageAfterSave}
        isOpen={this.isOpen}
        closable={false}
      >
        <div className="subhead">
          <TranslatedMessage
            id={'cart.membership_conflict_modal.existing_subscription'}
          />
        </div>
        <div className="text">
          <TranslatedMessage id={'cart.membership_conflict_modal.options'} />:
        </div>
        <Button
          onClick={this.handleManageSubscription}
          className="MembershipConflictModal__button MembershipConflictModal__button--manage-subscription"
        >
          {manageButtonText}
        </Button>
        <Button.Secondary
          onClick={this.handleOneOffPurchase}
          className="MembershipConflictModal__button MembershipConflictModal__button--one-off"
        >
          <TranslatedMessage
            id={'cart.membership_conflict_modal.one_time_purchase'}
          />
        </Button.Secondary>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/MembershipConflictModal.js